import { Button, HStack } from "@chakra-ui/react";
import { DatePicker } from "../datePicker/DatePicker";
import { Field, FieldProps, Form, Formik } from "formik";
import * as yup from "yup";

interface DateRangeSelectorProps {
  startDate: Date;
  endDate: Date;
  onSubmit?: (value: { startDate: string; endDate: string }) => void;
  openDate?: Date;
  onStartDateChange?: (value: string) => void;
  onEndDateChange?: (value: string) => void;
  okButtonVariant?: string;
  inputVariant?: string;
}

export const DateRangeSelector = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  openDate,
  okButtonVariant,
  onSubmit,
  inputVariant,
}: DateRangeSelectorProps) => {
  const schema = yup.object({
    startDate: yup.date().required(),
    endDate: yup.date().required(),
  });

  return (
    <>
      <Formik
        initialValues={{
          startDate: "",
          endDate: "",
        }}
        validationSchema={schema}
        onSubmit={(values) => {
          onSubmit !== undefined && onSubmit(values);
        }}
      >
        {({ isValid, touched, dirty, values }) => {
          const startDateLimits = {
            start: new Date(startDate),
            end: new Date(values.endDate || endDate),
          };

          const endDateLimits = {
            start: new Date(values.startDate || startDate),
            end: new Date(endDate),
          };

          return (
            <Form>
              <HStack w="100%">
                <HStack maxW={"24rem"}>
                  <Field name={"startDate"}>
                    {({ field, form }: FieldProps) => {
                      return (
                        <DatePicker
                          inputProps={{
                            field,
                            form,
                            variant: inputVariant,
                            onStartDateChange: (value: any) => {
                              if (onStartDateChange) {
                                onStartDateChange(value);
                              }
                            },
                            openDate: openDate,
                          }}
                          placeholder={"From"}
                          dateLimits={startDateLimits}
                        />
                      );
                    }}
                  </Field>
                  <Field name={"endDate"}>
                    {({ field, form }: FieldProps) => {
                      return (
                        <DatePicker
                          inputProps={{
                            field,
                            form,
                            variant: inputVariant,
                            onEndDateChange: (value: string) => {
                              if (onEndDateChange) {
                                onEndDateChange(value);
                              }
                            },
                            openDate: openDate,
                          }}
                          placeholder={"To"}
                          dateLimits={endDateLimits}
                        />
                      );
                    }}
                  </Field>
                </HStack>
                {isValid && !!touched && dirty && okButtonVariant && (
                  <Button
                    size={"sm"}
                    variant={okButtonVariant}
                    type={"submit"}
                    flexGrow={1}
                  >
                    Ok
                  </Button>
                )}
              </HStack>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
